import actions from './actions';
import functions from './functions';
import mutations from './mutations';
import getters from './getters';

export default {
    initVuex(vuexState, stateGetters, stateActions, stateMutations) {
        vuexState.player = null;
        Object.assign(stateGetters, getters);
        Object.assign(stateActions, actions);
        Object.assign(stateMutations, mutations);
    },
    initAppState(appState, store) {
        functions(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/player/index.js